export const environment = {
  production: true,
  env: 'staging',
  apiUrl: 'https://api-staging.caremessenger.co.uk/v2',
  signalingUrl: 'https://signal.bxthree.com',
  pusherKey: '2dd7fcb4e455b0869e43',
  ravenDsn: 'https://38905d172d76492b8b6c3c8cd9d97d2b@sentry.bxthree.com/41',
};
